<!-- 商品列表页 -->
<template>
	<div>
		<van-nav-bar
		  left-arrow
		  right-text="去首页"
		   @click-right="goIndex"
		  @click-left="goIndex"
		  placeholder
		  fixed
		/>	
		
<!-- 		<div style="position: relative;">
			<van-image
			height="180"
			width="100%"
			fit="cover"
			  :src="require('../../assets/ac1.jpg')"
			/>			
			<div style="position: absolute;top: 28%; color: #fff;font-size: 22px;font-weight: 550;text-align: center;width: 100%;" class="van-ellipsis">{{activityInfo.title}}</div>
			<div style="position: absolute;top: 50%; color: #fff;text-align: center;width: 100%;">
				<van-tag round color="rgba(255,255,255,.3)" text-color="#fff" style="padding: 5px; margin-right: 8px;" size="large">#产地直发</van-tag>
				<van-tag round color="rgba(255,255,255,.3)" text-color="#fff" style="padding: 5px; margin-right: 8px;" size="large">#农货上新</van-tag>
				<van-tag round color="rgba(255,255,255,.3)" text-color="#fff" style="padding: 5px; margin-right: 8px;" size="large">#源头好货</van-tag>
			</div>
			<div style="position: absolute;top:70%; display: flex;justify-content: center; align-items: center; width: 100%;" v-if="activityInfo.end_time-activityInfo.current_time">
				<van-count-down :time="(activityInfo.current_time>activityInfo.start_time)?(activityInfo.end_time-activityInfo.current_time)*1000:(activityInfo.start_time-activityInfo.current_time)*1000" style="display: inline;" >
				  <template #default="timeData">
					<span class="block">{{ timeData.days }}</span>
					<span class="colon">天</span>
					<span class="block">{{ timeData.hours }}</span>
					<span class="colon">小时</span>
					<span class="block">{{ timeData.minutes }}</span>
					<span class="colon">分钟</span>
					<span class="block">{{ timeData.seconds }}</span>
					<span class="colon">秒</span>
				  </template>
				</van-count-down>
				<span v-if="(activityInfo.current_time>activityInfo.start_time)" style="font-size: 16px; color: #ffffff;"> 后结束</span>
				<span v-else style="font-size: 16px; color: #ffffff;"> 后开始</span>	
			</div>
		</div>
		 -->
		<div class="activity-text" v-html="activityInfo.content"></div>
		<van-tabs v-model="active" style="padding: 10px  0;" background="#F5F5F5" color="#00C719" title-active-color='#00C719' title-inactive-color="#333" scrollspy sticky swipe-threshold=4>
			<van-tab v-for="(item,index) in activityInfo.activity_item_list" :key="index" :title="item.tag_name"  title-style="font-size:18px">
				<!-- 每个商品列表 -->
				<van-row v-for="(product,index) in item.item_list" :key="index" type="flex" class="card-box" @click="goProductInfo(product,activityInfo)">
					<!-- 商品图片 -->
				  <van-col span="6" style="padding: 2px;box-sizing: border-box;position: relative;padding-left: 10px; ">
					  <van-image v-if="product.flag_type"  fit="cover" :src="goodsTags[product.flag_type]" style="width: 30px; position: absolute; top: 2px;left: 8px;z-index: 2;"></van-image>
					  <van-image  fit="cover" :src="product.image[0]" lazy-load  height="90px" width="90px">
					  	<template v-slot:loading>
					  		<van-loading type="spinner" size="20" />
					  	</template>
					  </van-image>
				  </van-col>
				  <van-col span="18" style="padding: 5px 8px;">
					  <van-row style="display: flex; flex-direction: column; justify-content: space-between;">
					    <van-col style="width: 100%;" class="product-name van-ellipsis">{{product.name}}</van-col><!-- 商品名称 -->
					    <van-col style="width: 100%;" class="product-size"><span v-if="product.size">{{product.size}}/</span><span v-if="product.unit_name">{{product.unit_name}}</span> </van-col><!-- 商品规格 -->
						<van-col style="width: 100%;" v-if="product.limit_num" class="product-limit">每人限购{{product.limit_num}}{{product.unit_name}}</van-col><!-- 商品限购 -->
						<van-col style="width: 100%;" class="product-size" v-if="product.order_num">累计销量{{product.order_num}}{{product.unit_name}}</van-col><!-- 商品名称 -->
						<!-- 商品规格 -->
					    <van-col style="width: 100%;">
							<van-row type="flex" style="justify-content: center;align-items: center;">
								<van-col  class="product-price"><span>￥</span>{{(product.vip_price*1).toFixed(2)}}</van-col>						
								<van-col  style="flex:1;text-align: right;padding-right: 10px;">								
										<van-button color="#00C719" round disabled style="height: 30px;" v-if="product.stock<=0 && product.is_no_stock==2">
										  已售罄
										</van-button>
										<div v-else>
											<!-- <van-badge :content="product.groupCartNum ? product.groupCartNum : ''">
												<van-button color="#00C719" round @click.stop="getCart(product)" style="height: 30px;" >
												  马上参加
												</van-button>
											</van-badge>	 -->
											<van-icon name="cart" size="36" color="#00C719" :badge="product.groupCartNum ? product.groupCartNum : ''" @click.stop="getCart(product)" />
											
										</div>
																	
								</van-col>
							</van-row>
							<van-col style="width: 100%;" class="product-stock" v-if="product.is_no_stock == 2 && (product.stock-product.min_stock <= 0 && product.stock!== 0)">仅剩{{product.stock}}件</van-col>
						</van-col>
					  </van-row>
				  </van-col>
				</van-row>
			</van-tab>
		</van-tabs>	
		<!-- <van-divider>到底了</van-divider> -->
		<transition name="van-slide-up">
		
		  <!-- <div style="width: 70%; position: fixed;left: 15%;bottom: 70px; z-index: 999;" v-if="cartShow&&1&&cartTotalNum" >
		  	<van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="large" round  @click="goCart">
		  	 <van-icon name="cart-o" :badge="cartTotalNum" size="30" /><span>￥{{cartTotalPrice}}</span>
		  	</van-button>
		  </div> -->
		  <div style=" position: fixed;right: 16%;bottom: 20px; z-index: 999;" v-if="cartShow&&1&&cartTotalNum" >
		  	<van-button color="linear-gradient(to right, #ff6034, #ee0a24)" size="large" round  @click="goCart" style="padding:30px 20px;">
		  	 <van-icon name="cart-o" :badge="cartTotalNum" size="30" />
		  	</van-button>
		  </div>
		</transition>
		<!-- 弹出层 -->
<!-- 		<van-popup
		  v-model="show"
		  closeable
		  round
		  position="bottom"
		  :style="{ height: '70%' }">
		  
	
		  	<div class="goods-card"  v-if="cartList">
		  		<div class="cart-zone-title">已选商品{{cartTotalNum}}件</div>
		  		<van-divider />
		  		<div style="margin-bottom: 80px;">
		  			<van-swipe-cell v-for="(item,index) in cartList" :key="index" style="margin-bottom: 10px;" class="card-box">
		  				<van-card
		  				  class="good-card"
		  				  :price="item.vip_price.toFixed(2)"
		  				  :desc="item.size ? item.size+'/'+item.unit_name : ''"
		  				  :title="item.item_name"
		  				  :thumb="item.thumb_image"
						  centered
						   :tag='item.limit_num?"每人限购"+item.limit_num+"件":""'
		  				>
		  				  <template #footer>
		  						 <van-stepper v-model="item.goods_num"  min="0" @change="carNumChange(item)" :max='item.limit_num?item.limit_num:"999"' />
		  				  </template>	  
		  				</van-card>
		  				<template #right>
		  					<van-button square text="删除" type="danger" class="delete-button" @click="delCartItemAsync(item)"/>
		  				</template>
		  			</van-swipe-cell>	
		  		</div>	  			

		  		<van-submit-bar :price="cartTotalPrice*100" button-text="提交订单" @submit="onSubmit" style="margin-top: 20px;">
		  		</van-submit-bar>
		  	</div>
		  
		 
		</van-popup> -->
		<!-- <van-tabbar route placeholder safe-area-inset-bottom active-color="#42C052">
		   <van-tabbar-item replace to='/activityList' icon="home-o">首页</van-tabbar-item>
		   <van-tabbar-item replace to="/cart" icon="cart-o" :badge="cartTotalNum>0 ? cartTotalNum :''">购物车</van-tabbar-item>
		   <van-tabbar-item replace to="/userCenter" icon="user-o">我的</van-tabbar-item>
		 </van-tabbar> -->
	</div>		
</template>

<script>
import {mapState, mapGetters,mapActions} from 'vuex'	
export default {
  name: 'productList',
  
  data(){
	  return{
		active :0,//商品标签激活
		show:false,//弹出框开关
		activityInfo:{},//根据Id获取的活动详情
		cartShow:false,
		goodsTags:{
			'爆品':require('../../assets/hot_tag.png'),
			'热销':require('../../assets/sale_tag.png'),
			'新品':require('../../assets/new_tag.png'),
		},
	  }
  },
  methods:{ 
	  ...mapActions(['addCartAsync','modifyCartAsync','delCartItemAsync','getItemNum']),
	  //初始化活动商品列表
	  async init(id){
		await this.getActivityById(id)
		if(this.token){
			await this.$store.dispatch('cartGetAsync',id)
		}
		await this.$wxShare(id)
		this.cartShow=true
	  },
	  //进入商品详情页
	 async goProductInfo(currentInfo,activityInfo){
		 // let  ispre = 0
		 // if(activityInfo.start_time>activityInfo.current_time){
			//  ispre = 1
		 // }
		await this.$router.push({
			path:'productInfo',
			query:{
				//currentInfo:JSON.stringify(currentInfo),
				// ispre:JSON.stringify(ispre),
				id:currentInfo.id
				
			}
		})  
	  },
	  // 加购物车
	  getCart(params){
		  // if(!this.token){
			 //  localStorage.setItem("preRoute", this.$router.currentRoute.fullPath);
			 //  localStorage.setItem("isPreRoute", true);
		  // }
		
		this.$store.dispatch('addCartAsync',params)
	  },  
	  //提交购物车订单支付
	  onSubmit(){
	  	this.$router.push('/orderSubmit')
	  },						
	  //当购物车中商品数量变化时			
	  carNumChange(product){
	  	if(product.goods_num==0){
	  	  this.delCartItemAsync(product)
	  	} 
		else {
	  	  this.modifyCartAsync(product)
	  	}
	  },	  
	  //返回上级菜单
	backIndex() {
		  this.$router.push('/')
	    },
	goIndex(){
		 this.$router.push('/')
	},
	 //打开遮罩层
	 openCart(){
		 this.show=true		
	 },
	 //根据活动ID获取活动详情
	 getActivityById(id){
		this.request.postURL('/api/activity/getActivityById',{
		 	id:id,
		 }).then((res)=>{
			this.activityInfo=res.data.data
			this.setGroupGoodsBadage()
		 }).catch((err)=> {
		    
		   });
	 },
	 //设置团购商品角标
	 setGroupGoodsBadage(){
		if(this.groupList.hasOwnProperty(this.activityInfo.id)){
			let currentGroupList=this.groupList[this.activityInfo.id];
			for(var i= 0;i<this.activityInfo.activity_item_list.length;i++){
				for(var j=0;j<this.activityInfo.activity_item_list[i].item_list.length;j++){
					if(currentGroupList&&currentGroupList.hasOwnProperty(this.activityInfo.activity_item_list[i].item_list[j].item_id)){			
						this.activityInfo.activity_item_list[i].item_list[j].groupCartNum = currentGroupList[this.activityInfo.activity_item_list[i].item_list[j].item_id]				
					}
					else{
						this.activityInfo.activity_item_list[i].item_list[j].groupCartNum = ''
					}
				}
			}
		}
	 },
	 goCart(){
		 this.$router.push('/cart')
	 }
		
  },
  computed:{
	   ...mapState(['cartList','token','groupList','cartTotalNum']),
  },
  mounted() {
  	 
  },
  beforeDestroy() {
	    this.cartShow=false  
		//this.$store.commit('cartGet',[])
  },
  created() {
	  this.cartShow=false  
	  this.init(this.$route.query.id);	  
  },
  watch:{
	  cartTotalNum(){
		  if(this.cartTotalNum==0){
			  this.show=false
			  //把所有角标清除
			  for(var i= 0;i<this.activityInfo.activity_item_list.length;i++){
				  for(var j=0;j<this.activityInfo.activity_item_list[i].item_list.length;j++){
					  this.activityInfo.activity_item_list[i].item_list[j].groupCartNum = ''
				  }
			  }
		  }
		  
	  },
	  groupList:{
		  deep:true,
		  handler:function(to,from){
			this.setGroupGoodsBadage();	
			this.$forceUpdate()		
		  }
	  }
  },
}
</script>

<style>
	.card-box{
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid #eee;
		/* padding: 4px 0; */
	}
	.product-name{
		text-align: left;
		font-weight: 550;
	}
	.product-size{
		text-align: left;
		color: #888888;
		font-size: 14px;
	}
	.product-limit{
		text-align: left;
		color: red;
		font-size: 14px;
	}
	.product-price{
		flex: 1;
		text-align: left;
		font-size: 18px;
		color: red;
		font-weight: 550;
	}
	.product-stock{
		text-align:left;
		font-size: 14px;
		color:red;	
	}
	.product-price span{
		font-size: 14px;
		font-weight: 0;
	}
	.goods-card{
		width: 100%;
		text-align: left;
	}
	.good-card{
		background-color: #ffffff;
		padding: 0 20px;
	}
	.cart-zone-title{
		font-size: 16px;
		padding: 20px 0 0 20px;
	}
	.delete-button {
	    height: 100%;
	  }
	.back-index{
		width: 40px;
		height:40px;
		vertical-align: middle;
		background-color: rgba(255,255,255,.3);
		border-radius: 40px;
		position: absolute; 
		top: 3px; 
		left: 10px; 
		z-index:99;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.activity-text{
		padding:5px 20px;
		text-align: left;
	}
	.activity-text p{
		margin:0 0 8px 0;
	}
	.activity-text p img{
		
		
	}
	.activity-text1  p {
		margin: 0;
		padding: 0;
	}
	.activity-text1  p img{
		width: 100%;
	}
	.activity-text img{
		width: 100%;
	}
	.van-tab--active{
		font-weight: 800;
	}
	.colon {
	  display: inline-block;
	  margin: 0 4px;
	  color: #fff;
	  font-size: 16px;
	}
	.block {
	  display: inline-block;
	  width: 22px;
	  color: #fff;
	  font-size: 16px;
	  text-align: center;
	  background-color: #ee0a24;
	}
</style>
<style >
	
</style>
